<template>
  <div class="calico-list-item-page">
    <list-item>
      Sit ultrices dictum ut fringilla at sollicitudin turpis amet. Mauris viverra vivamus id aenean volutpat. A sit purus quis eget tellus pellentesque imperdiet elit faucibus. Gravida ullamcorper et nulla id ipsum dui. Nunc lobortis quam dolor massa in.
      Sed id massa enim vitae. Duis odio non eget blandit libero tristique diam odio sed.
    </list-item>
  </div>
</template>

<script lang="js">
import ListItem from '@/components/calico/listitem/index.vue'
export default {
  name: 'CalicoListItemPage',
  components: {
    ListItem
  },
  data () {
    return {}
  }
}
</script>
<style lang="scss">
</style>
